import React from "react";
import { useState } from "react";
import { IQuestion, QuestionType } from "src/network/fetchApplicationQuestions";

interface QuestionProps {
  question: IQuestion;
  handleAnswerChange: (questionNumber: string, value: string) => void;
}

function OptionsQuestion({
  question: questionItem,
  handleAnswerChange,
}: QuestionProps) {
  const { question, question_type, question_order, question_number, required } =
    questionItem;

  const [selected, setSelected] = useState("");

  function handleChange(event: any) {
    setSelected(event.target.id);
    handleAnswerChange(question_number, event.target.id === "yes" ? "1" : "0");
  }

  if (question_type === QuestionType.YesNo) {
    return (
      <div className="yes-no-container">
        <div className="yes-no-question-container">
          <p className="yes-no-question-text">{`${question.en} ${
            required && "*"
          }`}</p>
          <p className="yes-no-question-text">{question.ar}</p>
        </div>
        <div className="yes-no-answer">
          <label
            className={`yes-no-wrap yes ${
              selected === "yes" ? "selected" : ""
            }`}
          >
            <input
              id="yes"
              name={question.en}
              type="radio"
              onChange={handleChange}
            />
            Yes
          </label>
          <label
            className={`yes-no-wrap no ${selected === "no" ? "selected" : ""}`}
          >
            <input
              id="no"
              name={question.en}
              type="radio"
              onChange={handleChange}
            />
            No
          </label>
        </div>
      </div>
    );
  }
  return (
    <div className={"options"}>
      <p className="question-text">{question.en}</p>
      <div className="options">
        {["options"].map((option, index) => (
          <label key={index} className={"option-choice"}>
            <div className="radio-wrapper">
              <label className="radio-button">
                <input id={option} name={question.en} type="radio" />
                <span className="radio-checkmark"></span>
                <span className="radio-label">{option}</span>
              </label>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}

export default OptionsQuestion;
